<template>
    <form v-on:submit.prevent="submitForm">
        <DeliveryAddress
            :salutation-options="deliveryAddressSalutationOptions"
            :include-required-company="false"
            :include-date-of-birth="true"
            :date-of-birth-is-required="true"
            v-model:salutation="formData.deliveryAddress.salutation"
            v-model:first-name="formData.deliveryAddress.firstName"
            v-model:last-name="formData.deliveryAddress.lastName"
            v-model:street="formData.deliveryAddress.street"
            v-model:zip-code="formData.deliveryAddress.zipCode"
            v-model:city="formData.deliveryAddress.city"
            v-model:delivery-info="formData.deliveryAddress.deliveryInfo"
            v-model:phone="formData.deliveryAddress.phone"
            v-model:email="formData.deliveryAddress.email"
            v-model:date-of-birth="formData.deliveryAddress.dateOfBirth"
        />
        <p class="subheadline">Abweichende Rechnungsanschrift</p>
        <div class="control">
            <label for="differentBillingAddress-yes" class="radio">
                <input type="radio" id="differentBillingAddress-yes" :value="true"
                       v-model="formData.differentBillingAddress" />
                Ja
            </label>
            <label for="differentBillingAddress-no" class="radio">
                <input type="radio" id="differentBillingAddress-no" :value="false"
                       v-model="formData.differentBillingAddress" />
                Nein
            </label>
        </div>
        <BillingAddress
            v-if="askForBillingAddress"
            :salutation-options="billingAddressSalutationOptions"
            :include-optional-company="false"
            v-model:company="formData.billingAddress.company"
            v-model:salutation="formData.billingAddress.salutation"
            v-model:first-name="formData.billingAddress.firstName"
            v-model:last-name="formData.billingAddress.lastName"
            v-model:street="formData.billingAddress.street"
            v-model:zip-code="formData.billingAddress.zipCode"
            v-model:city="formData.billingAddress.city"
            v-model:phone="formData.billingAddress.phone"
            v-model:email="formData.billingAddress.email"
        />
        <Payment
            v-model:payment-method="formData.payment.method"
            v-model:bank-account-owner="formData.payment.bankAccountOwner"
            v-model:bank-name="formData.payment.bankName"
            v-model:bank-bic="formData.payment.bankBic"
            v-model:bank-iban="formData.payment.bankIban"
            v-model:bic-error="bicError"
            v-model:iban-error="ibanError"
            :allowed-payment-methods="allowedPaymentMethods"
        />
        <Password
            v-model:value="formData.password.value"
            v-model:compare="formData.password.compare"
            v-model:error="passwordError"
        />
        <Attention
            v-model:attention-type="formData.attention.type"
            v-model:attention-additional-text="formData.attention.additionalText"
        />
        <OptionsAndTermsAndCondition
            v-model:billing-via-email="formData.billingViaEmail"
            v-model:subscribe-to-newsletter="formData.subscribeToNewsletter"
            v-model:accepted-terms-and-conditions="formData.acceptedTermsAndConditions"
        />
        <SubmitButton />
    </form>
</template>

<script>
import BillingAddress from '@/views/components/ui/Register/Step1/Form/Part/BillingAddress'
import DeliveryAddress from '@/views/components/ui/Register/Step1/Form/Part/DeliveryAddress'
import Payment from '@/views/components/ui/Register/Step1/Form/Part/Payment'
import Password from '@/views/components/ui/Register/Step1/Form/Part/Password'
import Attention from '@/views/components/ui/Register/Step1/Form/Part/Attention'
import OptionsAndTermsAndCondition from '@/views/components/ui/Register/Step1/Form/Part/OptionsAndTermsAndCondition'
import SubmitButton from '@/views/components/ui/Register/Step1/Form/Part/SubmitButton'
import {allowedPaymentMethods, Destination} from "@/utils/registration";

export default {
    name: 'RegisterStep1FormHome',
    components: {
        BillingAddress,
        DeliveryAddress,
        Payment,
        Password,
        Attention,
        OptionsAndTermsAndCondition,
        SubmitButton
    },
    props: {
        registrationFormOptions: {
            type: Object,
            required: true,
        },
        initialRegistrationData: [Object, null]
    },
    data() {
        return {
            formData: {
                deliveryAddress: {
                    salutation: this.initialRegistrationData?.deliveryAddress?.salutation ?? '',
                    firstName: this.initialRegistrationData?.deliveryAddress?.firstName ?? '',
                    lastName: this.initialRegistrationData?.deliveryAddress?.lastName ?? '',
                    street: this.initialRegistrationData?.deliveryAddress?.street ?? '',
                    zipCode: this.initialRegistrationData?.deliveryAddress?.zipCode ?? '',
                    city: this.initialRegistrationData?.deliveryAddress?.city ?? '',
                    deliveryInfo: this.initialRegistrationData?.deliveryAddress?.deliveryInfo ?? '',
                    phone: this.initialRegistrationData?.deliveryAddress?.phone ?? '',
                    email: this.initialRegistrationData?.deliveryAddress?.email ?? '',
                    dateOfBirth: this.initialRegistrationData?.deliveryAddress?.dateOfBirth ?? '',
                },
                billingAddress: {
                    salutation: this.initialRegistrationData?.billingAddress?.salutation ?? '',
                    firstName: this.initialRegistrationData?.billingAddress?.firstName ?? '',
                    lastName: this.initialRegistrationData?.billingAddress?.lastName ?? '',
                    street: this.initialRegistrationData?.billingAddress?.street ?? '',
                    zipCode: this.initialRegistrationData?.billingAddress?.zipCode ?? '',
                    city: this.initialRegistrationData?.billingAddress?.city ?? '',
                    phone: this.initialRegistrationData?.billingAddress?.phone ?? '',
                    email: this.initialRegistrationData?.billingAddress?.email ?? '',
                },
                payment: {
                    method: this.initialRegistrationData?.payment?.method ?? '',
                    bankAccountOwner: this.initialRegistrationData?.payment?.bankAccountOwner ?? '',
                    bankName: this.initialRegistrationData?.payment?.bankName ?? '',
                    bankBic: this.initialRegistrationData?.payment?.bankBic ?? '',
                    bankIban: this.initialRegistrationData?.payment?.bankIban ?? ''
                },
                password: {
                    value: this.initialRegistrationData?.password?.value ?? '',
                    compare: this.initialRegistrationData?.password?.compare ?? '',
                },
                attention: {
                    type: this.initialRegistrationData?.attention?.type ?? '',
                    additionalText: this.initialRegistrationData?.attention?.additionalText ?? '',
                },
                billingViaEmail: this.initialRegistrationData?.billingViaEmail ?? false,
                subscribeToNewsletter: this.initialRegistrationData?.subscribeToNewsletter ?? false,
                acceptedTermsAndConditions: this.initialRegistrationData?.acceptedTermsAndConditions ?? false,
                differentBillingAddress: this.initialRegistrationData?.differentBillingAddress ?? false,
            },
            passwordError: '',
            ibanError: '',
            bicError: '',
        }
    },
    computed: {
        askForBillingAddress() {
            return this.formData.differentBillingAddress === true;
        },
        allowedPaymentMethods() {
            return allowedPaymentMethods(Destination.Home);
        },
        billingAddressSalutationOptions() {
            if (Array.isArray(this.registrationFormOptions.salutationOptions.billingAddress)) {
                return this.registrationFormOptions.salutationOptions.billingAddress
            }
            return [];
        },
        deliveryAddressSalutationOptions() {
            if (Array.isArray(this.registrationFormOptions.salutationOptions.deliveryAddress)) {
                return this.registrationFormOptions.salutationOptions.deliveryAddress
            }
            return [];
        },
    },
    methods: {
        submitForm() {
            if (this.passwordError || this.ibanError || this.bicError) {
                return
            }

            this.$emit('submitted', this.formData);
        }
    },
    emits: [
        'submitted'
    ]
}
</script>
